/**
 * Filename builder for downloaded agent-export JSON files.
 *
 * Pattern: stellar-agent-<slug>-<YYYYMMDD>.json
 *
 * Slug is the agent's name lowercased with runs of non-alphanumerics
 * collapsed to single dashes and leading/trailing dashes stripped.
 * Falls back to "agent" when the name reduces to an empty slug.
 * Date is the UTC calendar date so two admins in different timezones
 * exporting the same agent on the same UTC day get the same filename.
 */
export function buildExportFilename(agentName: string, when: Date): string {
  const slugRaw = agentName
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');
  const slug = slugRaw.length > 0 ? slugRaw : 'agent';
  const yyyy = when.getUTCFullYear().toString().padStart(4, '0');
  const mm = (when.getUTCMonth() + 1).toString().padStart(2, '0');
  const dd = when.getUTCDate().toString().padStart(2, '0');
  return `stellar-agent-${slug}-${yyyy}${mm}${dd}.json`;
}
